var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconFeatherUsersMult = function SvgIconFeatherUsersMult(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.232,
    height: 18.127,
    viewBox: "0 0 27.232 18.127",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.645 1.101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.745,27.842V26.061A3.561,3.561,0,0,0,12.184,22.5H5.061A3.561,3.561,0,0,0,1.5,26.061v1.781",
    transform: "translate(-1.5 -11.816)",
    fill: "none",
    stroke: "#f6c866",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.623,8.061A3.561,3.561,0,1,1,11.061,4.5,3.561,3.561,0,0,1,14.623,8.061Z",
    transform: "translate(-3.939 -4.5)",
    fill: "none",
    stroke: "#f6c866",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.671,27.921V26.141A3.561,3.561,0,0,0,30,22.7",
    transform: "translate(-13.084 -11.895)",
    fill: "none",
    stroke: "#f6c866",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,27.921V26.141A3.561,3.561,0,0,1,32.671,22.7",
    transform: "translate(-35.645 -11.895)",
    fill: "none",
    stroke: "#f6c866",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,4.7a3.561,3.561,0,0,1,0,6.9",
    transform: "translate(-10.645 -4.579)",
    fill: "none",
    stroke: "#f6c866",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.678,4.7a3.561,3.561,0,0,0,0,6.9",
    transform: "translate(-26.091 -4.579)",
    fill: "none",
    stroke: "#f6c866",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFeatherUsersMult, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-feather-users-mult.de6006f5.svg";
export { ForwardRef as ReactComponent };